import {
  ID,
  ResponseFill,
  HttpIgnore, IResource, ValidationCNPJ, ObjectCollection,
} from 'simpli-web-sdk'
import Motorista from '@/model/resource/Motorista'
import * as Helper from '@/helpers'
import DateFilterRequest from '@/model/request/DateFilterRequest'
import {ItrackCollection} from '@/helpers'
import {UF} from '@/enums/UF'
import {Region} from '@/enums/Region'
import {DeliverySlaStatus} from '@/enums/DeliverySlaStatus'
import {TipoSistema} from '@/enums/TipoSistema'
import {DeliveryAudit} from '@/enums/DeliveryAudit'
import {DeliveryAuditGeo} from '@/enums/DeliveryAuditGeo'

@HttpIgnore()
export default class DeliverySatisfactionSurveyHistoryRequest extends DateFilterRequest {
  readonly $name: string = 'DeliverySatisfactionSurveyHistoryRequest'

  allSistema = ItrackCollection.allSistema
  allCentroDeCusto = ItrackCollection.allCentroDeCusto.prependNull('app.all')
  allTipoInsumo = ItrackCollection.allTipoInsumo.prependNull('app.all')
  allSlaStatus = ItrackCollection.allSlaStatus.prependNull('app.all')
  allDocs = new ObjectCollection()
  allAuditGeo = ItrackCollection.allAuditGeo.prependNull('app.all')

  get ufCollection() {
    return ItrackCollection.getUfCollection(this.region).prependNull('app.all')
  }

  get regionCollection() {
    return ItrackCollection.allRegion.prependNull('app.all')
  }

  idFilial = Helper.getIdFilial()

  @ResponseFill('idMotorista')
  idMotorista: ID | null = null

  @ResponseFill('cpfCnpj')
  @ValidationCNPJ()
  documentDestinatario: string | null = null

  @ResponseFill('nroFiscal')
  docs: string | null = null

  @ResponseFill()
  uf: UF | null = null

  @ResponseFill()
  region: Region | null = null

  @ResponseFill()
  cidade: string | null = null

  @ResponseFill()
  sigla: string | null = null

  @ResponseFill()
  idCentroDeCusto: number | null = null

  @ResponseFill('auditoria')
  audit: DeliveryAudit | null = null

  @ResponseFill('auditoriaGeo')
  auditGeo: DeliveryAuditGeo | null = null

  get docsResource() {
    const str = String(this.docs || '')
    const docs = str.split(',')
    return this.allDocs.getMany(docs)
  }
  set docsResource(val: IResource[]) {
    this.docs = val.map((item: IResource) => item.$id).join(',')
  }

  get ufResource() {
    return this.ufCollection.get(this.uf)
  }
  set ufResource(val: IResource | null) {
    this.uf = val && val.$id as UF || null
  }

  get regionResource() {
    return this.regionCollection.get(this.region)
  }
  set regionResource(val: IResource | null) {
    this.region = val && val.$id as Region || null
  }

  get centroDeCustoResource() {
    return this.allCentroDeCusto.get(this.idCentroDeCusto)
  }
  set centroDeCustoResource(val: IResource | null) {
    this.idCentroDeCusto = val && val.$id as number || null
  }

  get auditGeoResource() {
    return this.allAuditGeo.get(this.auditGeo)
  }
  set auditGeoResource(val: IResource | null) {
    this.auditGeo = val && val.$id as DeliveryAuditGeo || null
  }

  populateAllDocs(val: IResource[]) {
    this.allDocs = new ObjectCollection(val)
  }

  cleanDocs() {
    this.docs = ''
  }
}
